import PropTypes from 'prop-types'

export const mediaPropTypes = PropTypes.shape({
  alternativeText: PropTypes.string,
  url: PropTypes.string
})
